import React, { createContext } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { ReactEditor } from 'slate-react';
import { useSharedTranscript } from '@utils/providers/shared-transcript-context.tsx';

interface TranscriptEditorLevelHotkeyContextType {}

const SharedTranscriptEditorLevelHotkeyContext = createContext<
  TranscriptEditorLevelHotkeyContextType | undefined
>(undefined);

interface TranscriptEditorLevelHotkeyProviderProps {
  children: React.ReactNode;
  editor: ReactEditor;
}

export function SharedTranscriptEditorLevelHotkeyProvider({
  children,
  editor
}: TranscriptEditorLevelHotkeyProviderProps) {
  const { document, startStopWord, applyStyle } = useSharedTranscript();

  // ctrl+b apply bold style
  useHotkeys(
    ['ctrl+b', 'meta+b'],
    () => {
      applyStyle('bold', null, editor);
    },
    {
      enableOnFormTags: true,
      preventDefault: true,
      enableOnContentEditable: true
    },
    [document, editor, startStopWord]
  );

  // ctrl+i apply italic style
  useHotkeys(
    ['ctrl+i', 'meta+i'],
    () => {
      applyStyle('italic', null, editor);
    },
    {
      enableOnFormTags: true,
      preventDefault: true,
      enableOnContentEditable: true
    },
    [document, editor, startStopWord]
  );

  // ctrl+u apply underline style
  useHotkeys(
    ['ctrl+u', 'meta+u'],
    () => {
      applyStyle('underlined', null, editor);
    },
    {
      enableOnFormTags: true,
      preventDefault: true,
      enableOnContentEditable: true
    },
    [document, editor, startStopWord]
  );

  // ctrl+s apply strike style
  useHotkeys(
    ['ctrl+s', 'meta+s'],
    () => {
      applyStyle('strike', null, editor);
    },
    {
      enableOnFormTags: true,
      preventDefault: true,
      enableOnContentEditable: true
    },
    [document, editor, startStopWord]
  );

  return (
    <SharedTranscriptEditorLevelHotkeyContext.Provider
      value={{
        editor
      }}
    >
      {children}
    </SharedTranscriptEditorLevelHotkeyContext.Provider>
  );
}
